module.exports = __webpack_public_path__ + "static/marketing-digital-7569065f104d701aff7ba7cc59ceac89.svg";